'use strict';

module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /workspace/donate-gro-release/~/react/react.js
// module id = 3
// module chunks = 0 1 2 3 4 5 6